import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {  // 存放状态
        user: {},
        isLogin: false
    },
    mutations: {  // 同步改变状态
        Set_Login(state, payload) {  // 登录
            state.isLogin = payload;
        },
        SET_USER(state, user) {  // 登录
            state.user = user;
        },
    },
    actions: {  // 异步改变状态
        login({ commit }, user) {
            // 模拟登录操作，实际应用中应该是API调用
            commit('Set_Login', true);
            commit('SET_USER', user);
        },
        logout({ commit }) {
            commit('Set_Login', false);
            commit('SET_USER', null);
        }
    },
    getters: {  // 计算属性

    },


})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js